import { Directive } from '@angular/core';

@Directive({
  selector: 'xpo-ltl-popover-content',
  host: { class: 'xpo-ltl-Popover-content' },
})
export class XpoLtlPopoverContent {}
